import * as React from 'react';

import { ArtworkTableTheme } from '../../enums';
import { AttributeWithValue } from '../../interfaces';

import { Container, Label, Row, Value } from './artworkTable.styled';
import { ArtworkTableProps } from './artworkTable.types';

export const ArtworkTable: React.FC<ArtworkTableProps> = (props: ArtworkTableProps): JSX.Element => {
  const { className, artworkTableTheme = ArtworkTableTheme.Horizontal, attributes }: ArtworkTableProps = props;

  return (
    <Container className={className}>
      {attributes.map((attribute: AttributeWithValue) => (
        <Row $theme={artworkTableTheme} key={attribute.label}>
          <Label $theme={artworkTableTheme}>{attribute.label}</Label>
          <Value>{attribute.value}</Value>
        </Row>
      ))}
    </Container>
  );
};
